/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputCategoryComponent = {
    template: require('./gmao-input-category.html'),
    bindings: {
        category: '<',
        inputs: '='
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputCategory.js